import axios from 'axios';

import { POST_EMISSION_DOCUMENTS_URL } from '../constants/constants';

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json;charset=utf-8',
});

export const postEmissionDocuments = (token, emissionId) => {
  return axios.post(POST_EMISSION_DOCUMENTS_URL, { emissionId }, { headers: headers(token) });
};
